import React from "react";

function Checkout() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Checkout</h1>
      <p>Fill in your shipping information and submit your order here.</p>
    </div>
  );
}

export default Checkout; 